import type { IconData } from '@stacksjs/iconify-core'

export const task: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m222.085 235.644l-62.01-62.01L81.8 251.905l62.009 62.01l-.04.04l66.958 66.957l11.354 11.275l.04.039l66.957-66.957l11.273-11.354l202.277-202.271l-78.272-78.271Zm44.33 66.958l-11.274 11.353l-33.057 33.056l-.04-.039l-33.017-33.017l.04-.04l-62.009-62.01l33.016-33.016l62.01 62.009L424.356 78.627l33.017 33.017Z\"/><path fill=\"currentColor\" d=\"M448 464H48V64h300.22l32-32H16v464h464V179.095l-32 32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default task
